import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import PageBase from 'components/common/PageBase';
import CrashDashboard from 'containers/crashDashboard/CrashDashboard';

class CrashDashboardPage extends Component {
    render() {
        const { translate} = this.props;
        return (
            <PageBase title={translate('CrashDashboard.title')} showGoToButtons={false}>
                <CrashDashboard/>
            </PageBase>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    };
}

export default connect(mapStateToProps)(CrashDashboardPage);


// WEBPACK FOOTER //
// ./src/pages/crashDashboard/CrashDashboardPage.js